export default __webpack_public_path__ + "static/media/engine-per-100.20593b28.svg";